
export * from '../../frontend-editor-ckeditor-web/__liferay__/exports/@ckeditor$ckeditor5-react.js';
